var _circle, _circle2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenCircles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 107,
    viewBox: "0 0 152 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120.519,
    cy: 72.1979,
    r: 31.1979,
    transform: "rotate(180 120.519 72.1979)",
    fill: "#EDF0F3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.301,
    cy: 53.301,
    r: 53.301,
    transform: "rotate(180 53.301 53.301)",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 53.301,
    y1: 106.609,
    x2: 53.301,
    y2: 0.0018923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BED635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0132,
    stopColor: "#BAD537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1293,
    stopColor: "#A0CD49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2481,
    stopColor: "#8DC756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3701,
    stopColor: "#82C45D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7EC360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42B469"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCircles);
export default __webpack_public_path__ + "static/media/GreenCircles.ade13d86153f70d16eb084e619315fff.svg";
export { ForwardRef as ReactComponent };